"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayCategory = void 0;
var QueryString = require("qs");
// [Display Category]
exports.displayCategory = function (axios) {
    return {
        getDisplayCategories: function (request) {
            return axios.get('/display-categories', request);
        },
        putDisplayCategoriesSync: function (request) {
            return axios.put("/display-categories/sync?mallNo=" + request.params.mallNo, request.data);
        },
        getDisplayCategoriesTree: function (request) {
            return axios.get('/display-categories/tree', request);
        },
        getDisplayCategoriesViews: function (request) {
            return axios.get('/display-categories/views', request);
        },
        getDisplayCategoriesExcel: function (request) {
            return axios.get('/display-categories/excel', request);
        },
        postDisplayCategoriesExcel: function (_a) {
            var data = _a.data;
            return axios.post('/display-categories/excel', data);
        },
        getDisplayCategoriesExcelFailHistories: function (_a) {
            var params = _a.params;
            return axios.get("/display-categories/excel/fail-histories?historyId=" + params.historyId, { responseType: 'blob' });
        },
        getDisplayCategoriesDuplicateManagementCode: function (_a) {
            var params = _a.params;
            var query = QueryString.stringify(params);
            return axios.get("/display-categories/duplicate/management-code?" + query);
        }
    };
};
